<template>
  <div class="loading" v-loading="loading" ></div>
</template>

<script>
export default {
    name: 'kyc',
    data() {
        return {
            loading: true
        }
    },
    mounted() {
        const token = this.$route.query.token
        const kycToken = this.$route.query.kycToken
        const tradeAccId = this.$route.query.tradeAccId
        const username = this.$route.query.username
        const sdkScript = document.createElement('script')
        const self = this
        sdkScript.src = `https://static.saasexch.com/static/binance/static/kyc-ui/sdk/0.0.2/sdk.js`
        document.body.appendChild(sdkScript)
        sdkScript.onload = () => {
            if (BinanceKyc) {
                const binanceKyc = new BinanceKyc({
                    authToken: kycToken,
                    bizEntityKey: 'JGZ',
                    apiHost: 'https://dip-qacb.sdtaop.com',
                    lng: 'zh-CN',
                    onMessage: ({ typeCode, data }) => {
                        self.loading = false
                        if (typeCode === '102') {
                            const params = {
                                certifyStatus: 'AUDITING',
                                tradeAccId: tradeAccId
                            }
                            self.$MyAxios.init({
                                token: token,
                                username: username
                            })
                            self.$MyAxios.post(`/api/user/kyc/save`, params, false, response => {
                                if(response.code === 1) {
                                    console.log('成功')
                                }
                            })
                            if (window.binanceDataMap && window.binanceDataMap.kycVisible) {
                                return binanceKyc.switchVisible(true)
                            }
                            let timer = null
                            timer = setInterval(() => {
                                if (window.binanceDataMap && window.binanceDataMap.kycVisible) {
                                    binanceKyc.switchVisible(true)
                                    clearInterval(timer)
                                }
                            }, 400);
                        }
                    }
                })
            }
        }
    },
    methods: {

    }
}
</script>

<style lang='less'>
.loading {
    height: 100vh;
}
.el-loading-spinner .path {
    stroke: #FFA41F;
}
</style>